import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, WhatsappLogo } from "@phosphor-icons/react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import WhatsAppFab from "../components/WhatsAppFab";
import Mentor from "../components/Mentor";
import { openWhatsapp } from "../lib/whatsapp";

export default function MentorPage() {
  return (
    <div
      data-testid="mentor-page-root"
      className="min-h-screen bg-[#F4F3ED] text-[#0A0A0A] font-body"
    >
      <Navbar />
      <main className="pt-28 lg:pt-32">
        <div className="px-5 lg:px-10 max-w-[1320px] mx-auto mb-4">
          <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E]">
            <Link to="/" className="hover:text-[#0A0A0A]">
              Home
            </Link>{" "}
            / Mentor
          </div>
        </div>
        <Mentor />
        <section className="px-5 lg:px-10 py-16 lg:py-20 border-t border-[#D4D0C5]">
          <div className="max-w-[1100px] mx-auto text-center">
            <h2 className="font-display font-black text-3xl sm:text-5xl tracking-tighter mb-5">
              Train under a working professional.
            </h2>
            <p className="font-body text-base text-[#4A4A4A] max-w-2xl mx-auto mb-8">
              Vishnu Sir trades the same markets he teaches — every market day.
              That's the difference between an instructor who reads books and
              one who reads tape.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/course"
                data-testid="mentor-cta-course"
                className="inline-flex items-center justify-center gap-3 bg-[#0A0A0A] text-[#F4F3ED] px-6 py-3.5 font-body text-sm uppercase tracking-[0.22em] hover:bg-[#D9381E] transition-colors"
              >
                See the course <ArrowRight weight="bold" size={16} />
              </Link>
              <button
                onClick={() => openWhatsapp()}
                data-testid="mentor-cta-whatsapp"
                className="inline-flex items-center justify-center gap-3 bg-[#25D366] text-[#0A0A0A] px-6 py-3.5 font-body text-sm uppercase tracking-[0.22em] font-bold hover:bg-[#1ebd5b] transition-colors"
              >
                <WhatsappLogo size={18} weight="fill" /> WhatsApp Mentor
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
